const FIXTURES = [
  {
    label: 'Client list',
    userText: '[Test] Show client cards',
    chunks: [
      'Here are some of your recent clients:\n\n',
      '<interaction type="result">',
      '<entity type="matter" uid="matter001" name="Sarah Johnson" last_activity_time="2026-01-05T10:00:00.000Z" contact_uid="contact001" contact_email="sarah@example.com" contact_phone="+1234567890" contact_name="Sarah Johnson" />',
      '<entity type="matter" uid="matter002" name="David Cohen" last_activity_time="2026-02-20T10:00:00.000Z" contact_uid="contact002" contact_email="david@example.com" contact_phone="" contact_name="David Cohen" />',
      '</interaction>',
    ],
  },
  {
    label: 'Upcoming appointments',
    userText: 'show me upcoming appointments',
    chunks: [
      'Here are your upcoming appointments:\n\n',
      '<interaction type="result">',
      '<entity type="appointment" uid="appt001" start_time="2026-05-20T10:00:00.000Z" state="scheduled" client_first_name="Sarah" client_last_name="Johnson" service="In-office consultation" staff_name="Alex Miller" location="In-person" />',
      '</interaction>',
    ],
  },
  {
    label: 'Book appointment (HITL)',
    userText: 'book appointment for sarah',
    chunks: [
      'Sure, I can book that for you. Please confirm:\n\n',
      '<interaction type="confirm" uid="int_test_code">',
      '<markdown>Book an **In-office consultation** with Sarah Johnson on May 20 at 10:00 AM?</markdown>',
      '<entity type="appointment" uid="appt001" start_time="2026-05-20T10:00:00.000Z" state="requested" client_first_name="Sarah" client_last_name="Johnson" service="In-office consultation" />',
      '</interaction>',
    ],
  },
  {
    label: 'Error',
    userText: '[Test] error',
    isError: true,
    chunks: [],
  },
  {
    label: 'Markdown / help',
    userText: 'help',
    chunks: [
      '## What I can help with\n\n',
      '- **Clients** — find, update, or message a client\n',
      '- **Appointments** — schedule, reschedule, or cancel\n\n',
      '<suggestions>',
      '<suggestion>Show me my clients</suggestion>',
      '<suggestion>Show me upcoming appointments</suggestion>',
      '</suggestions>',
    ],
  },
];

const CONFIRM_REPLIES = {
  int_test_code: {
    yes: ['Appointment booked successfully! Sarah Johnson is confirmed for May 20 at 10:00 AM.'],
    no: ['Got it, I\'m keeping them as-is. Let me know if you need anything else.'],
  },
  __llm__: {
    yes: ['Got it, the action has been confirmed. Let me know if you need anything else.'],
    no: ['Understood, keeping them unchanged. Feel free to ask if you change your mind.'],
  },
};

export const TEST_FIXTURES = FIXTURES;

export const findFixtureByUserText = (text) => {
  const normalized = (text || '').trim().toLowerCase();
  return FIXTURES.find((f) => f.userText.toLowerCase() === normalized) || null;
};

export const findReplyChunks = (uid, confirm) => {
  // eslint-disable-next-line no-underscore-dangle
  const entry = uid ? CONFIRM_REPLIES[uid] : CONFIRM_REPLIES.__llm__;
  if (!entry) return null;
  return entry[confirm] || null;
};
